import React, { useEffect, useState } from "react";
import "../adminprompts.css";
import {createAdminPrompt, getAdminPrompts} from "../services/adminPrompts";

export default function AdminPromptsClean() {
  const [apiData, setApiData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPrompt, setCurrentPrompt] = useState({});
  const [promptName, setPromptName] = useState('');
  const [promptSlug, setPromptSlug] = useState('');
  const [promptDescription, setPromptDescription] = useState('');
  const [versionTag, setVersionTag] = useState('');
  const [isError, setIsError] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");

  const [systemPrompt, setSystemPrompt] = useState('');
  const [formData, setFormData] = useState({
    slug: "",
    description: "",
    version: "",
  });

  const [postData, setpostData] = useState({
    prompt_name: "",
    prompt_slug: "",
    versions:[],
  });

  const slug = str => str.toLowerCase().trim().replace(/\s+/g, '_').replace(/[^\w_]/g, '');
  useEffect(() => {
    if(apiData.length == 0)
    getAdminPrompts()
    .then((jsonData) => setApiData(jsonData.data))
    .catch((error) => console.error("Error fetching JSON:", error));
  }, []);

  const handleEdit = (prompt) => {
    setCurrentPrompt(prompt);
    setFormData({
      slug: prompt.slug || "",
      description: prompt.description || "",
      version: prompt.version.version || "",
    });
    setIsModalOpen(true);
  };

  const handleVersionEdit = (promptId, versionTag) => {
    setCurrentPrompt(prompt);
    setFormData({
      slug: prompt.slug || "",
      description: prompt.description || "",
      version: prompt.version.version || "",
    });
    setIsModalOpen(true);
  };

  const handleSubmit = () => {
    
    const body =  {
      "prompt_name": promptName,
      "prompt_slug": promptSlug,
      "versions": [
        {
         
          "version_tag": versionTag,
          "prompt": systemPrompt,
          "is_active": true
        }
      ]
    }

    createAdminPrompt(body).then(data=>{
      getAdminPrompts()
    .then((jsonData) => {
      setIsModalOpen(false);
      setPromptName('');
      setPromptSlug('');
      setVersionTag('')
      setSystemPrompt('')
      setApiData(jsonData.data)
      
    })
    .catch((error) => console.error("Error fetching JSON:", error));
    

    }).catch((e)=>{
      setIsError(true);
      setErrorMessage(e.message);
    })
  };


  const handleActivate = (prompt) => {
    setCurrentPrompt(prompt);
    setFormData({
      slug: prompt.slug || "",
      description: prompt.title || "",
      version: prompt.version || "",
    });
    setIsModalOpen(true);
  };

  return (
    <div className="Accordins-container my-4">
      <div className="header d-flex">
        <h1 className="mb-4">Admin Prompts</h1>
        <button
          className="newbutton"
          type="button"
          onClick={() => {
            handleEdit({ slug: "", description: "", version: "" });
          }}
        >
          + Add New
        </button>
      </div>

      <div className="accordion" id="adminPromptsAccordion">
        {apiData.map((item, index) => (
          <div className="accordion-item" key={index}>
            <h2 className="accordion-header" id={`heading-${index}`}>
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse-${index}`}
                aria-expanded="false"
                aria-controls={`collapse-${index}`}
              >
                {/* TODO : Fix this  */}
                <div className="headerContainer">
                  <div className="nameTitle">{item.prompt_name}</div>
                  <div className="descirptionName">{item.description}</div>
                </div>
              </button>
            </h2>
            <div
              id={`collapse-${index}`}
              className={`accordion-collapse collapse`}
              aria-labelledby={`heading-${index}`}
              data-bs-parent="#adminPromptsAccordion"
            >
              <div className="accordion" id="adminPromptsVersionAccordion">
              <div className="newVersion">
                <button
                  className="newbutton"
                  type="button"
                  onClick={() => {
                    handleEdit({ slug: "", description: "", version: "" });
                  }}
                >
                  + Add Version
                </button>
              </div>
                {item.versions.map((version, versionIndex) => (
                  <div
                    className="accordion-item accordion-item-child"
                    key={versionIndex}
                  >
                    <h2
                      className="accordion-header"
                      id={`heading-${item.prompt_slug}-${versionIndex}`}
                    >
                      <div
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${item.prompt_slug}-${versionIndex}`}
                        aria-expanded="false"
                        aria-controls={`collapse-${item.prompt_slug}-${versionIndex}`}
                      >
                        {version.version_tag}
                        <div className="ms-3 d-flex align-items-center">
                          {version.is_active ? (
                            <>
                              <i className="bi bi-check-circle-fill text-success me-1"></i>{" "}
                              {/* Green Tick */}
                              <span>Active</span>
                            </>
                          ) : (
                            <>
                              <i className="bi bi-x-circle-fill text-danger me-1"></i>{" "}
                              {/* Red Cross */}
                              <span>Inactive</span>
                            </>
                          )}
                        </div>
                      </div>
                    </h2>
                    <div
                      id={`collapse-${item.prompt_slug}-${versionIndex}`}
                      className={`accordion-collapse collapse`}
                      aria-labelledby={`heading-${item.prompt_slug}-${versionIndex}`}
                      data-bs-parent="#adminPromptsVersionAccordion"
                    >
                      <div className="accordion-body">
                        <div className="title">{version.prompt}</div>
                        <button
                          className="btn btn-primary btn-sm edit-button"
                          onClick={() =>
                            handleEdit({
                              slug: item.prompt_slug,
                              description: version.prompt,
                              version: version,
                            })
                          }
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-primary btn-sm edit-button"
                          onClick={() => handleActivate(item)}
                        >
                          {version.is_active ? "Inactivate" : "Activate"}
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal Popup for Editing */}
      {/* TODO: Modal should take in as per the UI */}
      {/* TODO: There should be an add new version button */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button
              className="modal-close"
              onClick={() => setIsModalOpen(false)}
            >
              &times;
            </button>
            <h3>Create Prompt</h3>
            <form>
              <div className="form-group">
                <label className="mb-2">Prompt Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={promptName}
                  onChange={(e) =>{
                    setPromptName(e.target.value)
                    setPromptSlug(slug(e.target.value))
                  }  
                  }
                />
                <label className="mb-2" style={{color:"red"}}>slug: {promptSlug}</label>
              </div>
              <div className="form-group">
                <label className="mb-2">Prompt Description</label>
                <textarea
                  className="form-control"
                  value={promptDescription}
                  onChange={(e) =>
                    setPromptDescription( e.target.value )
                  }
                ></textarea>
              </div>
              <div className="form-group">
                <label className="mb-2">Version Tag</label>
                <input
                  type="text"
                  className="form-control"
                  value={versionTag}
                  onChange={(e) =>
                    setVersionTag(e.target.value)
                  }
                />
              </div>
              <div className="form-group">
                <label className="mb-2">System Prompt</label>
                <textarea
                  className="form-control"
                  value={systemPrompt}
                  onChange={(e) =>
                    setSystemPrompt(e.target.value)
                  }
                ></textarea>
              </div>
              <button
                type="button"
                className="btn btn-success mt-3"
                onClick={handleSubmit}
              >
                Submit
              </button>
              {isError ? <label className="mb-2" style={{color:"red"}}>Error: {ErrorMessage}</label> : null}
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
